import { createTheme } from '@mui/material/styles';
import shippoTheme from '../styles/shippoTheme.js';

const getVariantStyle = (theme, variant) => {
    switch (variant) {
        case 'table':
            return {
                tooltip: {
                    background: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    boxShadow: theme.shadows[5],
                },
                arrow: {
                    color: theme.palette.background.paper,
                },
            };
        case 'secondary':
            return {
                tooltip: {
                    background: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                    boxShadow: theme.shadows[5],
                },
                arrow: {
                    color: theme.palette.secondary.main,
                },
            };
        default:
            return {
                tooltip: {},
                arrow: {},
            };
    }
};
const tooltipTheme = createTheme(shippoTheme, {
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: ({ ownerState, theme }) => getVariantStyle(theme, ownerState.variant).tooltip,
                arrow: ({ ownerState, theme }) => getVariantStyle(theme, ownerState.variant).arrow,
            },
            defaultProps: {
                arrow: true,
            },
        },
    },
});

export { tooltipTheme as default };
//# sourceMappingURL=Tooltip.theme.js.map
